import React from 'react';
import {WithPermission} from 'admin-on-rest';
import {resolveAccess} from '../shared/authFunctions';
import {Card, CardHeader, CardText, CardActions} from 'material-ui/Card';
import {ViewTitle} from 'admin-on-rest/lib/mui';
import {FlatButton} from 'material-ui';
import Avatar from 'material-ui/Avatar';
import ListIcon from 'material-ui/svg-icons/action/view-list';
import InventoryIcon from 'material-ui/svg-icons/action/assignment';
import {fuseLocationInventoryIcon as LocationInventoryIcon} from './locationInventory';
import {fuseRepackIcon as RepackIcon} from './repackRetailBox';
import {fuseTransferAuditIcon as TransferAuditIcon} from './transferAudit';
import {fuseTransferredProductsIcon as TransferredProductsIcon} from './transfer';
import {fuseLocationAuditIcon as LocationAuditIcon} from './locationAudit';
import {fuseIncomingTransferIcon as IncomingTransferIcon} from './transfer';
import {fuseMissingIcon as MissingIcon} from './missing';
import {dashStyles} from '../shared/styles-dashboard';

export default () => (
    <div>
        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory'])}>
            <Card style={{...dashStyles.dash, ...dashStyles.marginBottom}}>
                <InventoryIcon style={dashStyles.dashIcon}/>
                <ViewTitle title="Inventory"/>
                <CardText>Everything related to Location Inventory.</CardText>
            </Card>
        </WithPermission>

        <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory', 'inventory_vo'])}>

            {/* Location Inventory */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <CardHeader
                    title="Location Inventory"
                    subtitle="Manage inventory for a single Location or view inventory levels in all Locations."
                    avatar={<Avatar icon={<LocationInventoryIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory'])}>
                        <p>
                            Search for a Location to view a list of its Inventory. Add Inventory Adjustments up
                            or down as needed, or clear the Location's Inventory (such as if a season has
                            closed). Inventory is shown as a positive or negative quantity of Product Units,
                            not as a total.
                        </p>
                        <p>
                            Search all Locations with positive, negative or zero Inventory, or search by
                            Product Name.
                        </p>
                        <hr style={dashStyles.break}/>
                    </WithPermission>
                    <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['inventory_vo'])}>
                        <p>
                            Search for a Location to view a list of its Inventory. Inventory is shown as a
                            positive or negative quantity of Product Units, not as a total.
                        </p>
                        <p>
                            Search all Locations with positive, negative or zero Inventory, or search by
                            Product Name.
                        </p>
                        <hr style={dashStyles.break}/>
                    </WithPermission>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View Single Location Inventory" href="#/LocationInventory"/>
                    <FlatButton icon={<ListIcon/>} label="Search Inventory Levels" href="#/LocationInventoryLevels"/>
                </CardActions>
            </Card>

            {/* Repack / Retail Box Management */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}
                  className="listCard">
                <CardHeader
                    title="Repack / Retail Box Management"
                    subtitle="Find Repacks and Retail Boxes and view their Inventory contents."
                    avatar={<Avatar icon={<RepackIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        Search for Repacks or Retail Boxes within a specified date range. Optionally, search
                        by Collection ID to find Repacks and Retail Boxes, or search by Product name to find
                        Products within a Repack or Retail Box.
                    </p>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="Find Repacks or Retail Boxes"
                                href="#/InventoryRepacksRetailBoxes"/>
                </CardActions>
            </Card>

            {/* Transfers Management */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <CardHeader
                    title="Transfers Management"
                    subtitle="Manage transfers of Inventory between Locations. Click to read more."
                    avatar={<Avatar icon={<IncomingTransferIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        When Inventory is being transferred from one Location to another, such as stocking a Location
                        from a warehouse or returning stock to a storage Location, this area monitors the Inventory in
                        transit or Inventory that was received.
                    </p>
                    <p>
                        You may search for Transfers in transit, Transfers marked as received, or search by Memo.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View Incoming Transfers" href="#/InventoryTransfers"/>
                    <FlatButton icon={<ListIcon/>} label="View Received Transfers" href="#/ReceivedInventoryTransfers"/>
                    <FlatButton icon={<ListIcon/>} label="View Transfers by Memo" href="#/InventoryTransfersByMemo"/>
                </CardActions>
            </Card>

            {/* Transferred Products Management */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <CardHeader
                    title="Transferred Products Management"
                    subtitle="Find Inventory being transferred between Locations. Click to read more."
                    avatar={<Avatar icon={<TransferredProductsIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        This area provides searching for Products in Transfers from one Location to
                        another, such as stocking a Location from a warehouse or returning stock to a storage
                        Location.
                    </p>
                    <p>
                        You may search for Products within Transfers in transit, Transfers marked as received,
                        Repacks, or Retail Boxes.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="Search Transferred Products" href="#/TransferredProducts"/>
                </CardActions>
            </Card>

            {/* Transfer Audits */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory'], [])}>
                    <CardHeader
                        title="Transfer Audits"
                        subtitle="Modify Transfers and Totals."
                        avatar={<Avatar icon={<TransferAuditIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={false}
                        showExpandableButton={false}
                    />
                </WithPermission>
                <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['inventory_vo'])}>
                    <CardHeader
                        title="Transfer Audits"
                        subtitle="View Transfers and Totals."
                        avatar={<Avatar icon={<TransferAuditIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={false}
                        showExpandableButton={false}
                    />
                </WithPermission>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="View All Transfer Audits" href="#/InventoryTransferAudits"/>
                </CardActions>
            </Card>

            {/* Location Audits */}
            <WithPermission resolve={(props) => resolveAccess(props.permissions, ['inventory'])}>
                <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                    <CardHeader
                        title="Location Audits"
                        subtitle="Modify Quantities and Close out Locations."
                        avatar={<Avatar icon={<LocationAuditIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                    <CardText expandable={true}>
                        <p>
                            When a Location has finished its season or is otherwise ready to close, a POS User creates
                            an
                            Audit of its Inventory that remains or will be returned to a storage Location. Use this
                            section
                            to
                            review Audits and finalize them, or finalize them and close out the Location.
                        </p>
                    </CardText>
                    <CardActions>
                        <FlatButton icon={<ListIcon/>} label="View All Location Audits" href="#/LocationAudits"/>
                    </CardActions>
                </Card>
            </WithPermission>
            <WithPermission resolve={(props) => resolveAccess(props.permissions, [], ['inventory_vo'])}>
                <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}} className="listCard">
                    <CardHeader
                        title="Location Audits"
                        subtitle="View Audit Quantities."
                        avatar={<Avatar icon={<LocationAuditIcon/>} style={dashStyles.avatar}/>}
                        actAsExpander={true}
                        showExpandableButton={true}
                    />
                    <CardText expandable={true}>
                        <p>
                            When a Location has finished its season or is otherwise ready to close, a POS User creates
                            an
                            Audit of its Inventory that remains or will be returned to a storage Location. Use this
                            section
                            to
                            review Audits.
                        </p>
                    </CardText>
                    <CardActions>
                        <FlatButton icon={<ListIcon/>} label="View All Location Audits" href="#/LocationAudits"/>
                    </CardActions>
                </Card>
            </WithPermission>


            {/* Missing Scans */}
            <Card style={{...dashStyles.listCard, ...dashStyles.marginBottom}}>
                <CardHeader
                    title="Missing Scans"
                    subtitle="Monitor scanned barcodes that are not found in the system. Click to read more."
                    avatar={<Avatar icon={<MissingIcon/>} style={dashStyles.avatar}/>}
                    actAsExpander={true}
                    showExpandableButton={true}
                />
                <CardText expandable={true}>
                    <p>
                        When scanning a Product with the POS System, the System attempts to locate the barcode
                        as a Product Unit, a Product, or a Loyalty Account.
                    </p>
                    <p>
                        Occasionally the barcode cannot be found in the System. This may be due to the Product
                        not yet existing at the time, or an Alias needed for the Product, or the barcode
                        belonging to a Product that is not sold by this store.
                    </p>
                    <p>
                        Search for barcodes scanned since a specific date.
                    </p>
                    <hr style={dashStyles.break}/>
                </CardText>
                <CardActions>
                    <FlatButton icon={<ListIcon/>} label="Find Missing Scans" href="#/MissingScans"/>
                </CardActions>
            </Card>

        </WithPermission>
    </div>
);



// WEBPACK FOOTER //
// ./src/Fuse/Inventory/dashboard.js